export default "__VITE_ASSET__BbLFP_Ej__"